var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 2.41675C5.81192 2.41675 2.41675 5.81192 2.41675 10.0001C2.41675 14.1882 5.81192 17.5834 10.0001 17.5834C14.1882 17.5834 17.5834 14.1882 17.5834 10.0001C17.5834 5.81192 14.1882 2.41675 10.0001 2.41675ZM0.916748 10.0001C0.916748 4.9835 4.9835 0.916748 10.0001 0.916748C15.0167 0.916748 19.0834 4.9835 19.0834 10.0001C19.0834 15.0167 15.0167 19.0834 10.0001 19.0834C4.9835 19.0834 0.916748 15.0167 0.916748 10.0001ZM10.8334 13.3334C10.8334 13.7937 10.4603 14.1667 10.0001 14.1667C9.53984 14.1667 9.16675 13.7937 9.16675 13.3334C9.16675 12.8732 9.53984 12.5001 10.0001 12.5001C10.4603 12.5001 10.8334 12.8732 10.8334 13.3334ZM9.08341 8.33342C9.08341 7.82715 9.49382 7.41675 10.0001 7.41675C10.5063 7.41675 10.9167 7.82715 10.9167 8.33342V8.43451C10.9167 8.70444 10.8095 8.96332 10.6187 9.15418L9.46975 10.3031C9.17686 10.596 9.17686 11.0709 9.46975 11.3637C9.76264 11.6566 10.2375 11.6566 10.5304 11.3637L11.6793 10.2148C12.1515 9.74267 12.4167 9.10227 12.4167 8.43451V8.33342C12.4167 6.99873 11.3348 5.91675 10.0001 5.91675C8.66539 5.91675 7.58341 6.99873 7.58341 8.33342V8.75008C7.58341 9.1643 7.9192 9.50008 8.33341 9.50008C8.74763 9.50008 9.08341 9.1643 9.08341 8.75008V8.33342Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.2e8cb355c22d52c201877d4cf02222a2.svg";
export { ForwardRef as ReactComponent };